import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/UsersThree.es.js";
const r = e.forwardRef((o, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...o, weights: a }));
r.displayName = "UsersThreeIcon";
const n = r;
export {
  n as UsersThree,
  r as UsersThreeIcon
};
